<app-state-section [state]="sectionState">
  <div class="wrapper">
    <div class="row">
      <span class="label col-auto">{{ "TransportationPayments.CreatedBy" | translate }}:</span>
      <p class="data col-auto p-0">{{ createdBy }}</p>
    </div>

    <div class="row mt-3">
      <span class="label col-auto">{{ "TransportationPayments.From" | translate }}:</span>
      <p class="data col-auto p-0">{{ startFrom | date: 'dd LLL YYYY' }}</p>
    </div>

    <div class="row mt-3">
      <span class="label col-auto">{{ "TransportationPayments.To" | translate }}:</span>
      <p class="data col-auto p-0">{{ endAt | date: 'dd LLL YYYY' }}</p>
    </div>

    <div class="row mt-3">
      <span class="label col-auto">{{ "TransportationPayments.TotalAmount" | translate }}:</span>
      <p class="data col-auto p-0">{{ totalAmount.toLocaleString() }}</p>
    </div>

    <div class="row mt-3">
      <span class="label col-auto">{{ "TransportationPayments.NoOfShipments" | translate }}:</span>
      <p class="data col-auto p-0">{{ selectedShipments.length }}</p>
    </div>

    <form class="form-group mt-5" [formGroup]="form">
      <div class="form-control">
        <mat-label class="label">{{ "TransportationPayments.PaymentDate" | translate}}:</mat-label>
        <app-date-input formControlName="paymentDate" [required]="true"></app-date-input>
      </div>

      <div class="form-control flex column">
        <mat-label class="label">{{ "TransportationPayments.BankRef" | translate}}:</mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="text" [placeholder]="'Placeholder.EnterTheValue' | translate" formControlName="bankRef" />
          <mat-error *ngIf=" form.invalid && form.get('bankRef').hasError('maxlength')">
            {{ "ErrorMessages.InValidLength" | translate: {length: 50 } }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex justify-space-between mt-3">
        <button mat-raised-button class="btn-secondary btn" (click)="closeModal.emit()">{{'Buttons.Cancel' | translate}}</button>
        <button mat-raised-button class="btn-primary btn" (click)="save()" [disabled]="form.invalid">{{'Buttons.Save' | translate}}</button>
      </div>
    </form>
  </div>
</app-state-section>
